// extracted by mini-css-extract-plugin
export var galleryContainer = "team-module--galleryContainer--QV311";
export var teamMember = "team-module--teamMember--z4vgv";
export var teamImage = "team-module--teamImage--SNANx";
export var name = "team-module--name--Fhz0a";
export var job = "team-module--job--RLu2e";